import { defineMessages } from 'react-intl';

export const referenceChipMessages = defineMessages({
  patient: {
    id: 'PRDgdz1CsM',
    defaultMessage: 'Patient',
    description:
      'Generic label on a chat reference chip to a patient that is loading or failed to load',
  },
  session: {
    id: 'pVzaiL5iSe',
    defaultMessage: 'Session',
    description:
      'Generic label on a chat reference chip to a session that is loading or failed to load',
  },
  document: {
    id: 'NMoydnKbFA',
    defaultMessage: 'Document',
    description:
      'Generic label on a chat reference chip to a document that is loading or failed to load',
  },
  library_document: {
    id: '4RhqnTjH6r',
    defaultMessage: 'Document',
    description:
      'Kind noun read by screen readers before the name on a composer chip to a library document',
  },
  template: {
    id: 'wdhqt/h41C',
    defaultMessage: 'Template',
    description:
      'Generic label on a chat reference chip to a template that is loading or failed to load',
  },
  routine: {
    id: 'PBTjjh9FRk',
    defaultMessage: 'Routine',
    description:
      'Generic label on a chat reference chip to a routine that is loading or failed to load',
  },
  project: {
    id: 'n1yTNdKZMp',
    defaultMessage: 'Chat',
    description:
      'Generic label on a chat reference chip to another Work chat that is loading or failed to load',
  },
  task: {
    id: 'wxfTj6xs6n',
    defaultMessage: 'Task',
    description:
      'Generic label on a chat reference chip to a clinical task that is loading or failed to load',
  },
  letter: {
    id: 'LvEde2mb2F',
    defaultMessage: 'Letter',
    description:
      'Generic label on a chat reference chip to a letter that is loading or failed to load',
  },
  file: {
    id: '+ELIHbfJlp',
    defaultMessage: 'File',
    description:
      'Generic label on a chat reference chip to a library file that is loading or failed to load',
  },
  collection: {
    id: 'Z4si+8PEpZ',
    defaultMessage: 'Collection',
    description:
      'Generic label on a chat reference chip to a library collection that is loading or failed to load',
  },
  source: {
    defaultMessage: 'Source',
    id: 'tQtvCq5XFa',
    description:
      'Generic label on a chat reference chip to a cited source, such as a guideline or web page',
  },
  patientUnavailable: {
    id: 'WXnmM2SzKu',
    defaultMessage: 'Patient unavailable',
    description:
      'Chat reference chip to a patient the user cannot open (deleted or no access)',
  },
  sessionUnavailable: {
    id: '1VWMiYrnR8',
    defaultMessage: 'Session unavailable',
    description:
      'Chat reference chip to a session the user cannot open (deleted or no access)',
  },
  documentUnavailable: {
    id: 'rQK5RSEbAa',
    defaultMessage: 'Document unavailable',
    description:
      'Chat reference chip to a document the user cannot open (deleted or no access)',
  },
  templateUnavailable: {
    id: '3p8NzYVm2Q',
    defaultMessage: 'Template unavailable',
    description:
      'Chat reference chip to a template the user cannot open (deleted or no access)',
  },
  routineUnavailable: {
    id: 'SRtV3l0HZd',
    defaultMessage: 'Routine unavailable',
    description:
      'Chat reference chip to a routine the user cannot open (deleted or no access)',
  },
  projectUnavailable: {
    id: 'bi1sWL9j+P',
    defaultMessage: 'Chat unavailable',
    description:
      'Chat reference chip to another Work chat the user cannot open (deleted or no access)',
  },
  taskUnavailable: {
    id: '3nsl16bWHM',
    defaultMessage: 'Task unavailable',
    description:
      'Chat reference chip to a clinical task the user cannot open (deleted or no access)',
  },
  letterUnavailable: {
    id: 'bGXUm6rWB5',
    defaultMessage: 'Letter unavailable',
    description:
      'Chat reference chip to a letter the user cannot open (deleted or no access)',
  },
  fileUnavailable: {
    id: '/Tr3fAPdvc',
    defaultMessage: 'File unavailable',
    description:
      'Chat reference chip to a library file the user cannot open (deleted or no access)',
  },
  collectionUnavailable: {
    id: 'sSHnIJRoDn',
    defaultMessage: 'Collection unavailable',
    description:
      'Chat reference chip to a library collection the user cannot open (deleted or no access)',
  },
  sourceUnavailable: {
    defaultMessage: 'Source unavailable',
    id: 'eTfBaAQzbk',
    description: 'Chat reference chip to a cited source that has no title to show',
  },
  retry: {
    id: 'lyiZyA3Qe8',
    defaultMessage: 'Retry',
    description:
      'Accessible label of the button that retries loading a chat reference chip',
  },
});
